import ShopType from "@/enum/ShopType";

export const TbPlatform = [
    /** 淘宝 */
    {
        to: `/setting/shop/add/platform?type=${ShopType.TAOBAO}`,
        alt: ShopType.TAOBAO,
        image: "//img.alicdn.com/imgextra/i4/54458674/O1CN01fOprAy2DwkARNFfGA_!!54458674.jpg",
    },
    /** 天猫 */
    {
        to: `/setting/shop/add/platform?type=${ShopType.TAOBAO}`,
        alt: ShopType.TAOBAO,
        image: "//img.alicdn.com/imgextra/i3/54458674/O1CN01kcxYZk2DwkAVyHKpp_!!54458674.jpg",
    },
    /** 淘特 */
    {
        to: `/setting/shop/add/platform?type=${ShopType.TAOBAO}`,
        alt: ShopType.TAOBAO,
        image: "//img.alicdn.com/imgextra/i2/54458674/O1CN01Xy81Wh2DwkAdkNssX_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.TAOBAO_DISTRIBUTION}`,
        alt: ShopType.TAOBAO_DISTRIBUTION,
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN01ivSIoO2DwkAYZMdC5_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.ALIBABA}`,
        alt: ShopType.ALIBABA,
        image: "//img.alicdn.com/imgextra/i2/54458674/O1CN01b9UpYr2DwkANNiBgX_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.ALI_C2M}`,
        alt: ShopType.ALI_C2M,
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN016giEVW2DwkAPyCaKJ_!!54458674.jpg",
    },
];

export const PddPlatform = [
    {
        to: `/setting/shop/add/platform?type=${ShopType.PINDUODUO}`,
        alt: ShopType.PINDUODUO,
        image: "//img.alicdn.com/imgextra/i2/54458674/O1CN01ObUANj2DwkSJVp2lk_!!54458674.png",
    },
];

export const AllPlatform = [
    {
        to: `/setting/shop/add/platform?type=${ShopType.PINDUODUO}`,
        alt: ShopType.PINDUODUO,
        image: "//img.alicdn.com/imgextra/i2/54458674/O1CN01ObUANj2DwkSJVp2lk_!!54458674.png",
    },
    /** 淘宝 */
    {
        to: `/setting/shop/add/platform?type=${ShopType.TAOBAO}`,
        alt: ShopType.TAOBAO,
        image: "//img.alicdn.com/imgextra/i4/54458674/O1CN01fOprAy2DwkARNFfGA_!!54458674.jpg",
    },
    /** 天猫 */
    {
        to: `/setting/shop/add/platform?type=${ShopType.TAOBAO}`,
        alt: ShopType.TAOBAO,
        image: "//img.alicdn.com/imgextra/i3/54458674/O1CN01kcxYZk2DwkAVyHKpp_!!54458674.jpg",
    },
    /** 淘特 */
    {
        to: `/setting/shop/add/platform?type=${ShopType.TAOBAO}`,
        alt: ShopType.TAOBAO,
        image: "//img.alicdn.com/imgextra/i2/54458674/O1CN01Xy81Wh2DwkAdkNssX_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.TAOBAO_DISTRIBUTION}`,
        alt: ShopType.TAOBAO_DISTRIBUTION,
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN01ivSIoO2DwkAYZMdC5_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.DOUDIAN}`,
        alt: ShopType.DOUDIAN,
        image: "//img.alicdn.com/imgextra/i4/54458674/O1CN010pQWQa2DwkExr73Jk_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.JD}`,
        alt: ShopType.JD,
        image: "//img.alicdn.com/imgextra/i3/54458674/O1CN01R6og462DwkAQ1VkeG_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.JD_PURCHASE}`,
        alt: ShopType.JD_PURCHASE,
        image: "//img.alicdn.com/imgextra/i4/54458674/O1CN01qUAuzl2DwkVep8if1_!!54458674.png",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.ALIBABA}`,
        alt: ShopType.ALIBABA,
        image: "//img.alicdn.com/imgextra/i2/54458674/O1CN01b9UpYr2DwkANNiBgX_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.DOUDIAN_IOP}`,
        alt: ShopType.DOUDIAN_IOP,
        image: "//img.alicdn.com/imgextra/i4/54458674/O1CN01GFJgcM2DwkHlGlDkj_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.DOUDIAN_SUPPLIER}`,
        alt: ShopType.DOUDIAN_SUPPLIER,
        image: "//img.alicdn.com/imgextra/i2/54458674/O1CN01OPf4hv2DwkF2V0DpC_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.KWAI}`,
        alt: ShopType.KWAI,
        image: "//img.alicdn.com/imgextra/i3/54458674/O1CN01DOlMUX2DwkAReHUY4_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.CHANNEL_SHOP}`,
        alt: ShopType.CHANNEL_SHOP,
        image: "https://img.alicdn.com/imgextra/i3/54458674/O1CN01Z6tBLg2DwkYvhEsRg_!!54458674.png",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.CHANNEL_SHOP_DROPSHIP}`,
        alt: ShopType.CHANNEL_SHOP_DROPSHIP,
        image: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01OKIJBw2DwkYvl6M0i_!!54458674.png",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.CHANNEL_SHOP_SUPPLIER}`,
        alt: ShopType.CHANNEL_SHOP_SUPPLIER,
        image: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01OKIJBw2DwkYvl6M0i_!!54458674.png",
    },

    {
        to: `/setting/shop/add/platform?type=${ShopType.XIAOHONGSHU}`,
        alt: ShopType.XIAOHONGSHU,
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN01474qK72DwkAWqzEYW_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.ALI_C2M}`,
        alt: ShopType.ALI_C2M,
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN016giEVW2DwkAPyCaKJ_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.KWAI_DROPSHIP}`,
        alt: ShopType.KWAI_DROPSHIP,
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN019iFCC02DwkHYZfaf5_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.KTT}`,
        alt: ShopType.KTT,
        image: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01qpSdvo2DwkNQnBukN_!!54458674.png",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.WEIDIAN}`,
        alt: ShopType.WEIDIAN,
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN017GICYV2DwkAWqv8sG_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.AIKUCUN}`,
        alt: ShopType.AIKUCUN,
        image: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01YZfmmD2DwkAVyFBVx_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.SUNING}`,
        alt: ShopType.SUNING,
        image: "https://img.alicdn.com/imgextra/i3/54458674/O1CN01KH7WLs2DwkAUDpcIZ_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.HAIZIWANG}`,
        alt: ShopType.HAIZIWANG,
        image: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01JNBdeu2DwkANy6Vh2_!!54458674.jpg",
    },
    /** 鲸灵 */
    {
        to: `/setting/shop/add/platform?type=${ShopType.WEBUY}`,
        image: "https://img.alicdn.com/imgextra/i2/54458674/O1CN0134bGkx2DwkHeY2xf9_!!54458674.jpg",
        alt: ShopType.WEBUY,
    },
    /** 好衣库（鲸灵） */
    {
        to: `/setting/shop/add/platform?type=${ShopType.WEBUY}`,
        image: "https://img.alicdn.com/imgextra/i3/54458674/O1CN019M7gnh2DwkASp1ure_!!54458674.jpg",
        alt: ShopType.WEBUY,
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.YOUZAN}`,
        alt: ShopType.YOUZAN,
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN01p0QYwy2DwkAQ1Xpkn_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.DUXIAODIAN}`,
        alt: ShopType.DUXIAODIAN,
        image: "//img.alicdn.com/imgextra/i3/54458674/O1CN01Sv9SV02DwkAVH2O2i_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.WEIMOB_EC}`,
        alt: ShopType.WEIMOB_EC,
        image: "//img.alicdn.com/imgextra/i4/54458674/O1CN01PdUbvx2DwkAQYhlCy_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.MOGUJIE}`,
        alt: ShopType.MOGUJIE,
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN014YFHtR2DwkAVyIk6y_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.DOUBB}`,
        alt: ShopType.DOUBB,
        image: "https://img.alicdn.com/imgextra/i1/54458674/O1CN01Rqw74Y2DwkWBUZYXI_!!54458674.jpg",
    },
    {
        to: `/setting/shop/add/platform?type=${ShopType.INDEPENDENT_MANUAL}`,
        alt: ShopType.INDEPENDENT_MANUAL,
        image: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01JFKvxC2DwkHYZVn4V_!!54458674.png",
    },
];
